import { Stack, Text, Title } from "@mantine/core"
import { Card, Grid } from "@tfg/ui"
import { useTranslation } from "react-i18next"
import { useOutletContext } from "react-router-dom"

import type { AdminResponses } from "@tfg/types/endpoints/admin"

import { FeatureAccessGrantCard } from "./components/FeatureAccessGrantCard"
import { PlanSettingsSection } from "./components/PlanSettingsSection"
import { useFeatureAccess } from "./hooks/use-feature-access"

export function FeatureAccess() {
  const { t } = useTranslation("admin")
  const organization = useOutletContext<AdminResponses.OrganizationDetails>()
  const { data: featureAccessGrants, update } = useFeatureAccess(
    organization.id
  )

  return (
    <Grid gutter="md" align="stretch">
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <Card h="100%">
          <Stack gap="md">
            <Stack gap={4}>
              <Title order={2}>
                {t("featureAccess.title", {
                  defaultValue: "Access management",
                })}
              </Title>
              <Text size="sm">
                {t("featureAccess.description", {
                  defaultValue:
                    "Manage which features this organization can access while access-management APIs are being merged.",
                })}
              </Text>
            </Stack>

            <Stack gap="sm">
              {featureAccessGrants.map((featureAccessGrant) => (
                <FeatureAccessGrantCard
                  key={`${featureAccessGrant.organizationId}-${featureAccessGrant.featureKey}`}
                  featureAccessGrant={featureAccessGrant}
                  onUpdate={(isActive) =>
                    update({
                      featureKey: featureAccessGrant.featureKey,
                      isActive,
                    })
                  }
                />
              ))}
            </Stack>
          </Stack>
        </Card>
      </Grid.Col>
      <PlanSettingsSection organization={organization} />
    </Grid>
  )
}
